import moment from 'moment'
import store from '../store'


export function calibratedCurrentTime() {
	const state = store.getState()	
	const clockOffset=state.clockSyncOffset || 0
	const currentTime =moment() 
	const calibratedCurrentTime=currentTime.add(clockOffset,'milliseconds')
	return calibratedCurrentTime.toISOString()
}


// WEBPACK FOOTER //
// ./src/utils/calibratedCurrentTime.js